import { languages, defaultLocale, fallbackLocale} from 'lang'
import { createI18n, useI18n } from 'vue-i18n'

const messages = Object.assign(languages)
const i18n = createI18n({
    legacy: false,
    locale: defaultLocale,
    fallbackLocale: fallbackLocale,
    globalInjection: true,
    legacy: false,
    messages
})

export default i18n;
